import type React from 'react';

export function PopoverContainer({ children }: { children: React.ReactNode }) {
    return (
        <div
            className="flex h-fit min-w-76 max-w-76 flex-col overflow-hidden rounded-xl border-0.5 border-control bg-base"
            style={{
                boxShadow:
                    'lch(0 0 0 / 0.022) 0px 6px 18px, lch(0 0 0 / 0.044) 0px 3px 9px, lch(0 0 0 / 0.044) 0px 1px 1px',
            }}
        >
            {children}
        </div>
    );
}
